import { Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    border: '1px solid #D9D9D9',
    borderRadius: 10,
    margin: '25px 0px',
    alignItems: 'center',
    padding: 44,
    [theme.breakpoints.down('sm')]: {
      padding: 10,
      textAlign: 'center',
    },
  },
  description: {
    textAlign: 'left',
    paddingRight: '10%',
    [theme.breakpoints.down('md')]: {
      paddingRight: 'unset',
      paddingBottom: 20,
      textAlign: 'center',
    },
  },
  inputGridItem: {
    display: 'flex',
    flexDirection: 'column !important', // Always stack vertically
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  inputContainer: {
    alignItems: 'center',
    width: '90%',
    borderColor: '#D9D9D9',
    [theme.breakpoints.down('md')]: {
      margin: '3%',
      width: '183px',
      backgroundColor: '#fafafa',
    },
  },
  input: {
    backgroundColor: '#fafafa',
    textAlign: 'center',
    border: '2px solid #e7e7e2',
    padding: '10px',
    borderRadius: 6,
    [theme.breakpoints.down('md')]: {
      borderColor: 'inherit',
      backgroundColor: 'inherit',
      borderRadius: 4,
      transition: 'border-color 0.3s',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    '&:focus-visible': {
      outlineColor: theme.palette.secondary.main,
    },
    '&:placeholder': {
      textAlign: 'center',
      color: '#9a9a96',
      opacity: 1,
    },
    '&:focus:placeholder': {
      color: 'transparent',
    },
  },
  allocationPercent: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
    },
  },
}));

export const AllocationSubtitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  [theme.breakpoints.down('md')]: {
    fontSize: 12,
  },
}));

export const PercentAllocationLabelTypography = styled(Typography)(
  ({ theme }) => ({
    fontSize: 10,
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: 8,
    },
    '&&': {
      color: '#797979',
    },
  })
);
export const PercentAllocationTypography = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    fontSize: 8,
  },
  '&&': {
    color: '#797979',
  },
}));
